import { StoreColumnExtractor } from './store-column-extractor';
export class StaticValueExtractor implements StoreColumnExtractor {
	constructor(private readonly value) {}
	public storeConfigDependencies(): any[] {
		return [];
	}
	public extractor(): (...storeData: any[]) => any {
		return () => this.value;
	}

	public getDataPointPath(): string {
		return '';
	}
}
